import PageTypeA from "../components/pageTypeA/PageTypeA";
import { pagesDataA } from "../data/pagesData";

const Page6 = () => {
  return (
    <PageTypeA title={pagesDataA[2].title} subtitle={pagesDataA[2].subtitle} image={pagesDataA[2].image}/>
  );
};

export default Page6;
